import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2025 from '../SchoolProgram2023/components/Sidebar2025';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const YogaDay2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/yogaday/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/yogaday/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/yogaday/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/yogaday/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/yogaday/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/school-programs/yogaday/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/school-programs/yogaday/7.webp`;
    const p8 = `${config.base_image_url_2026}/home/events-activities/school-programs/yogaday/8.webp`;
    const p9 = `${config.base_image_url_2026}/home/events-activities/school-programs/yogaday/9.webp`;




    const photos = [
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        }, 
      {
          src: p7,
          source: p7,
          rows: 1,
          cols: 1,
      },
      {
          src: p8,
          source: p8,
          rows: 1,
          cols: 1,
      },
      {
          src: p9,
          source: p9,
          rows: 1,
          cols: 1,
      }
//       {
//           src: p10,
//           source: p10,
//           rows: 1,
//           cols: 1,
//       }, 
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               INTERNATIONAL DAY OF YOGA : 2026-27
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Classes: Class 6 to 8    Date: 18 June 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                               <Typography variant={'subtitle1'} align={'justify'}>
  National Public School, Yeshwanthpur enthusiastically celebrated the <strong>12th International Day of Yoga</strong> on Thursday, 18 June 2026, with the objective of fostering a deeper understanding of yoga and its numerous benefits among students. The theme for this year, <strong>“Yoga for Healthy Ageing”</strong>, along with the sub-theme <strong>“Yoga for Wellness, Wisdom, and World Peace”</strong>, beautifully emphasized the interconnectedness of physical, social, and emotional well-being.
  <br></br>

  A dedicated group of students from Classes 6 to 8 actively participated in the school assembly, skillfully demonstrating a series of yoga asanas, including several advanced postures. Their synchronized performance highlighted the significance of yoga in enhancing physical fitness, concentration, and overall well-being.
  <br></br>

  In a separate activity, the students of Class 8 enthusiastically took part in a special yoga session conducted during the first three periods. They actively practised a variety of asanas and yogic techniques, gaining a deeper understanding of yoga as a means to promote a healthy, balanced, and holistic lifestyle.
  <br></br>

  To further enhance awareness, a quiz based on the theme was conducted for the students of Class 5. The students participated with great enthusiasm, gaining valuable knowledge about yoga and its significance.
  <br></br>

  A special yoga session was also organised for the teaching staff on Friday, 19 June 2026. During the session, they were guided through a range of asanas, including <strong>Yoga Nidra</strong>, specifically designed to strengthen physical health, build mental resilience, and promote emotional balance. Seated comfortably on chairs or yoga mats, the teachers practised rejuvenating techniques that encouraged deep relaxation of both the mind and body. By the end of the session, they expressed a profound sense of calm, rejuvenation, and well-being.
  <br></br>

  Overall, the celebration of the <strong>International Day of Yoga</strong> at National Public School, Yeshwanthpur reflected the institution’s steadfast commitment to promoting physical, mental, and emotional wellness among both students and staff.
  <br></br>
</Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
      "Embracing yoga today for a healthier tomorrow.”
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default YogaDay2026;